export const DRAWER_WIDTH = 256;

export const SITE_PREFERS_COLOR_SCHEME = "site-prefers-color-scheme";

export const COLOR_SCHEME_CODE_MAP = { DARK: "DARK", LIGHT: "LIGHT" };

export default {
  DRAWER_WIDTH,
  SITE_PREFERS_COLOR_SCHEME,
  COLOR_SCHEME_CODE_MAP
};
